/** Browser notifications — never prompt without a user gesture. */

export function canUseNotifications(): boolean {
  return typeof window !== "undefined" && "Notification" in window;
}

export function notificationPermission(): NotificationPermission | "unsupported" {
  if (!canUseNotifications()) return "unsupported";
  return Notification.permission;
}

export function showWaveNotification(title: string, body: string): void {
  if (!canUseNotifications() || Notification.permission !== "granted") return;
  try {
    new Notification(title, { body });
  } catch {
    /* ignore blocked notifications */
  }
}

/** Call only from click/key handler — browsers reject programmatic prompts. */
export async function requestNotificationPermissionFromGesture(): Promise<
  NotificationPermission | "unsupported"
> {
  if (!canUseNotifications()) return "unsupported";
  if (Notification.permission !== "default") return Notification.permission;
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}
